import {
  React,
  Component,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  SelectField,
  MenuItem,
  CircularProgress,
  Paper
} from 'material-ui';

const currencies = [
  <MenuItem key={0} value="USD" selected="selected" primaryText="Dolar Estadounidense"></MenuItem>,
  <MenuItem key={1} value="CLF" primaryText="UF Chilena"></MenuItem>,
  <MenuItem key={2} value="CLP" primaryText="Peso Chileno"></MenuItem>,
  <MenuItem key={3} value="VEB" primaryText="Bolivar Venezolano"></MenuItem>,
  <MenuItem key={4} value="CAD" primaryText="Dolar Canadiense"></MenuItem>,
  <MenuItem key={5} value="AUD" primaryText="Dolar Australiano"></MenuItem>,
  <MenuItem key={6} value="EUR" primaryText="Euro"></MenuItem>,
  <MenuItem key={7} value="PYG" primaryText="Guaraní Paraguayo"></MenuItem>,
  <MenuItem key={8} value="GBP" primaryText="Libra Esterlina"> </MenuItem>,
  <MenuItem key={9} value="ARP" primaryText="Peso Argentino"></MenuItem>,
  <MenuItem key={10} value="COP" primaryText="Peso Colombiano"></MenuItem>,
  <MenuItem key={11} value="BOP" primaryText="Peso Boliviano"></MenuItem>,
  <MenuItem key={12} value="MXP" primaryText="Peso Mexicano"></MenuItem>,
  <MenuItem key={13} value="UYU" primaryText="Peso Uruguayo"></MenuItem>,
  <MenuItem key={14} value="ZAR" primaryText="Rand Sudafricano"> </MenuItem>,
  <MenuItem key={15} value="BRR" primaryText="Real Brasilero"></MenuItem>,
  <MenuItem key={16} value="INR" primaryText="Rupia India"></MenuItem>,
  <MenuItem key={17} value="PEN" primaryText="Sol Peruano"></MenuItem>,
  <MenuItem key={18} value="CNY" primaryText="Yuan Chino"> </MenuItem>,
  <MenuItem key={19} value="JPY" primaryText="Yen Japonés"></MenuItem>,
]
const styles = {
  paper: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center'
  }
}

class CurrencySelect extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: false,
      loading: false,
      currency: "USD"
    }
  }

  componentDidMount() {
    this.getCurrency()
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar la moneda de tu empresa</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <Paper zDepth={1} style={styles.paper}>
        <div>Selecciona el tipo de cambio que utilizarás para medir tu intensidad de innovación</div>
        <div>
          <SelectField
              value={this.state.currency}
              onChange={this.handleChange}
              maxHeight={300}
            >
            {currencies}
          </SelectField>
        </div>
      </Paper>
    );
  }

  getCurrency = () => {
    let token = this.props.cookies.get('token');
    let user = this.props.cookies.get('user');

    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ token}
    });
    connection.get(routes.currency(user.company_id))
    .then((response) => {
      this.setState({
        currency: response.data.currency,
        error: false,
        loading: false
      });
      this.props.changeCurrency(response.data.currency);
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        error: true,
        loading: false
      })
    });
  }

  handleChange = (event, index, value) => {
    this.props.changeCurrency(value);
    this.setState({currency: value});
  }

}

export default withCookies(CurrencySelect);



// WEBPACK FOOTER //
// ./src/components/setup/CurrencySelect.js